/* eslint-disable max-len */
import FavoriteProduct from '../data/getData-idb';
import {createFavoriteBtn, createUnfavoriteBtn} from '../views/template/theme';

const FavoriteButton = {
  async init({likeButtonContainer, restaurant}) {
    this.likeButtonContainer = likeButtonContainer;
    this.restaurant = restaurant;
    await this.renderButton();
  },
  async renderButton() {
    const id = this.restaurant.id;
    const isFavorited = await this.isRestaurantExist(id);
    isFavorited ? this.renderLiked() : this.renderLike();
  },
  async isRestaurantExist(id) {
    const restaurant = await FavoriteProduct.getProduct(id);
    return !!restaurant;
  },
  renderLike() {
    this.likeButtonContainer.innerHTML = createFavoriteBtn();
    const likeButton = document.querySelector('#favoriteBtn');
    likeButton.addEventListener('click', async () => {
      await FavoriteProduct.putProduct(this.restaurant);
      this.renderButton();
    });
  },
  renderLiked() {
    this.likeButtonContainer.innerHTML = createUnfavoriteBtn();
    const likeButton = document.querySelector('#favoriteBtn');
    likeButton.addEventListener('click', async () => {
      await FavoriteProduct.deleteProduct(this.restaurant.id);
      this.renderButton();
    });
  },
};

export default FavoriteButton;
